<template>
    <v-text-field class="input-center-align centered-input ma-1" type="number" v-model.number="qty" label="Qty" size="12" dense
        @blur="updateValue()" :append-outer-icon="showDeleteIcon ? 'mdi-delete' : ''"
        @click:append-outer="$emit(appEvents.DELETE)">
        <template v-slot:prepend-inner>
            <v-icon size="large" :style="themeInverted" @click="decrement()">mdi-minus</v-icon>
        </template>
        <template v-slot:append>
            <v-icon size="large" :style="themeInverted" @click="increment()">mdi-plus</v-icon>
        </template>
    </v-text-field>
</template>

<script>
export default {
    props: {
        value:{
            type: Number,
            default: () => 1
        },
        step: {
            type: Number,
            default: () => 1 
        },
        min:{
            type: Number,
            default:() => 0
        },
        showDeleteIcon:{
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            quantity: 1
        }
    },
    computed: {
        qty: {
            get(){
                this.quantity = this.value >= 1 ? this.value : 1
                return this.quantity
            },
            set(newValue){
                this.quantity = newValue
                this.updateValue()
            }
        }
    },
    methods: {
        increment() {
            this.qty +=this.step
            this.updateValue()
        },
        decrement() {
            if(this.qty > this.min){
                this.qty -=this.step
                this.updateValue()
            }
        },
        updateValue(){
            this.$emit(this.appEvents.INPUT, this.quantity)
            this.$emit(this.appEvents.CHANGE, this.quantity)
        }
    },
}
</script>

<style scoped>
.quantity-control{
    color: orange !important;
    font-size: 30px !important;
}
.centered-input >>> input {
    text-align: center;
    font-size: 1.2rem;
}
</style>
